module.exports = __webpack_public_path__ + "static/media/DSC08783-2.2199113d.jpeg";